import DemandGeneration from "./DemandGeneration/DemandGeneration";
import DemandApproval from "./DemandApproval/DemandApproval";
import DemandRequest from "./DemandRequest";
import DemandRequestInwardList from "./DemandRequestInwardList";
import ViewDemandGeneration from "./DemandGeneration/ViewDemandGeneration";
import FundReleaseFromBDS from "./DemandGeneration/FundReleaseFromBDS";
import TrackBill from "./DemandGeneration/TrackBill";
import OldBillUpload from "./DemandGeneration/OldBillUpload";
import OldDemandApproval from "./DemandApproval/OldDemandApproval";
import ViewOldBills from "./DemandGeneration/ViewOldBills";
import EditDemandGeneration from "./DemandGeneration/EditDemandGeneration";
import RejectedWorksTracker from "./DemandGeneration/RejectedWorksTracker";

export {
  DemandGeneration,
  DemandApproval,
  DemandRequest,
  DemandRequestInwardList,
  ViewDemandGeneration,
  FundReleaseFromBDS,
  TrackBill,
  OldBillUpload,
  OldDemandApproval,
  ViewOldBills,
  EditDemandGeneration,
  RejectedWorksTracker,
};
